import CallTimeline from "./CallTimeline"
import Topics from "./Topics"
import CallRecording from "./CallRecording"
import LeadInsights from "./LeadInsights"
import Summaries from "./Summaries"
import Overview from "./Overview"
import Header from "./Header"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import SkeletonLoading from "./Skeleton"
import axios from "../../lib/axios.js";
import { useToast } from "../../hooks/use-toast.js";

const CallsPage = () => {
    const { id } = useParams();
    const [call, setCall] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { toast } = useToast();

    useEffect(() => {
        async function fetchCallData() {
            try {
                const response = await axios.get(`/calls/${id}`);
                setCall(response.data);
            } catch (err) {
                toast({
                    title: "Error",
                    description: "Failed to load Call Data.",
                    variant: "destructive",
                });
            } finally {
                setIsLoading(false);
            }
        }
        fetchCallData();
    }, [id, toast]);

    if (isLoading) {
        return <SkeletonLoading />
    }

    return (
        <div className="w-full max-w-7xl mx-auto space-y-4">
            <Header call={call}/>

            <Overview call={call} />

            <Summaries call={call}/>

            <LeadInsights call={call} />

            <div className="space-y-4">

                <Topics call={call} />

                <CallRecording call={call} />

                <CallTimeline call={call} />
            </div>
        </div>
    )
}

export default CallsPage;
